import { Component, inject } from "@angular/core";

import { TrpButtonComponent, TrpButtonType } from "@triparound/trp-components/button";
import { TrpIconComponent } from "@triparound/trp-components/shared";

import { CommonFacadeService } from "../../services/common-facade.service";
import { NavigationFacadeService } from "../../services/navigation-facade.service";

@Component({
	selector: "app-page-not-found",
	templateUrl: "./page-not-found.component.html",
	styleUrls: ["./page-not-found.component.scss"],
	imports: [TrpIconComponent, TrpButtonComponent],
})
export class PageNotFoundComponent {
	buttonType = TrpButtonType;

	private navigationFacade = inject(NavigationFacadeService);
	private commonFacade = inject(CommonFacadeService);

	redirectHome(): void {
		this.navigationFacade.go({ path: [this.commonFacade.baseUrl] });
	}
}
